<template>
  <v-dialog v-model="open" max-width="500px" persistent>
    <v-card flat>
      <v-card-title>
        <span>
          <v-icon class="icon">mdi-file</v-icon>
          {{ t(`adicionarArquivos`) }}
        </span>
      </v-card-title>
      <v-card-text>
        <form @submit.prevent="anexar()">
          <v-file-input
            v-model="files"
            chips
            multiple
            required
            v-if="atendimento.queueTypeID !== 4"
            :disabled="files && files.length == 1"
          ></v-file-input>
          <v-file-input
            v-model="files"
            chips
            multiple
            required
            v-else
          ></v-file-input>
          <v-text-field
            v-if="atendimento.queueTypeID !== 4"
            prepend-icon="mdi-closed-caption"
            v-model="legenda"
            :label="t(`legenda`)"
            required
          ></v-text-field>
          <b-progress
            show-progress
            :value="uploadStatus"
            :variant="`warning`"
            :key="`warning`"
          ></b-progress>
        </form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          :disabled="!files || (files.length === 1 && uploadStatus !== 0)"
          @click="anexar()"
          color="primary"
          >{{ t(`anexar`) }}</v-btn
        >
        <v-btn
          v-show="uploadStatus === 0"
          @click="
            cancelar();
            files = [];
          "
          >{{ t(`cancelar`) }}</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
   
<script>
import { mapActions } from "vuex";
import { mapState } from "vuex";

export default {
  name: "Transferencia",
  props: {
    open: { type: Boolean, default: false },
    atendimento: { type: Object, default: null },
  },
  data() {
    return {
      files: [],
      legenda: "",
    };
  },
  computed: {
    ...mapState("auth", {
      user: (state) => state.user,
    }),
    ...mapState("xc", {
      uploadStatus: (state) => state.uploadStatus,
    }),
  },
  methods: {
    ...mapActions("xc", [
      "getDefault",
      "getClassificacoes",
      "setClassificacao",
      "setClassificacaoLigacao",
    ]),
    anexar() {
      this.$emit("anexar", this.files);
    },
    cancelar() {
      this.$emit("cancelar", false);
    },
  },
};
</script>
<style>
</style>